// extracted by mini-css-extract-plugin
export default {"analysisPanel":"ObservationDetailPage_analysisPanel__g0BKy"};